import { render, staticRenderFns } from "./WithHeader.vue?vue&type=template&id=4f41715c"
import script from "./WithHeader.vue?vue&type=script&lang=js"
export * from "./WithHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports